module.exports = __webpack_public_path__ + "img/sg.7bcbf19d.svg";